export default __webpack_public_path__ + "static/lta-logo-d651aa42d6cb555df64b70f271cffdae.png";